import { render, staticRenderFns } from "./deposit_list.vue?vue&type=template&id=f07fe05c&scoped=true&"
import script from "./deposit_list.vue?vue&type=script&lang=js&"
export * from "./deposit_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07fe05c",
  null
  
)

export default component.exports